import { Component, Inject } from '@angular/core';
import { Customer } from '../../../models';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-customer-alert-dialog',
    template: ` <h1 mat-dialog-title>Customer Alert</h1>
    <div mat-dialog-content>
      <p *ngFor="let paragraph of paragraphs">{{ paragraph }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>`,
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, NgFor, MatDialogActions, MatButton, MatDialogClose]
})
export class CustomerAlertDialogComponent {
  paragraphs = this.data.popup_message.split('\n');

  constructor(@Inject(MAT_DIALOG_DATA) public data: Customer) {}
}
